<template>
    <section class="container-fluid p-0 bodyArea">
    <div class="containerBox">
      <div class="pageHeader row align-items-center" v-if="$auth.isAuthenticated">
        <div class="col-3 pageHeaderTitle">EPIC FHIR</div>
        <div class="col text-right">
          <div class="filterWrapper">
            <div class="filterText">Tenant :</div>
            <div class="dropdown col p-0">
              <model-select v-model="lastSelectedTenantObj" :options="tenants" name="text" id="value"
                            placeholder="Select Tenant" @input="validateSelection" class="tenantList">
              </model-select>
            </div>
          </div>
          <button class="btn btn-primary generalBtn" style="margin-left: 10px" @click.prevent="showEPHRModal($event)" :disabled="lastSelectedTenantObj==''">
            Add
          </button>
        </div>
      </div>
      
      <div class="pageDataWrapper">
        <div class="contentHeader row m-0 align-items-center">
          <div class="col">Id</div>
          <div class="col">Client Id</div>
          <div class="col flex-3">Scope</div>
          <div class="col flex-2">Tenant</div>
          <div class="col flex-2">MRN_MONIKER</div>
          <div class="col flex-2">MRN_SYSTEM_ID</div>
          <div class="col flex-2">MRN_FORMAT</div>
          <div class="col">isLab</div>
          <div class="col">isEcal</div>
          <div class="col">Release Version</div>

          <div class="col">Actions</div>
          
        </div>

        <div class="contentDataWrapBottom">
          <div v-for="FHIR in list" v-bind:key="FHIR._id">
            <div class="contentDataWrapper actions contentActualDataWrapper row m-0">
                <div class="contentData row m-0 align-items-center col-12 p-0">
                <div class="col">{{ FHIR._id }}</div>
                <div class="col">{{ FHIR.clientId }}</div>

                <div class="col flex-3">
                  {{ FHIR.scope }}
                </div>
                <div class="col flex-2">
                  {{ FHIR.tenant }}
                </div>
                <div class="col flex-2">
                  {{ (FHIR.MRN_MONIKER && FHIR.MRN_MONIKER !== '') ? FHIR.MRN_MONIKER : '--' }}
                </div>
                <div class="col flex-2">
                  {{ (FHIR.MRN_SYSTEM_ID &&FHIR.MRN_SYSTEM_ID !== '') ? FHIR.MRN_SYSTEM_ID : '--'}}
                </div>
                <div class="col flex-2">
                  {{ (FHIR.MRN_FORMAT &&FHIR.MRN_FORMAT !== '') ? FHIR.MRN_FORMAT  : '--'}}
                </div>
                <div class="col flex-2">
                    <input type="checkbox" :checked="isBoolean(FHIR.isLab)" disabled />
                </div>
                <div class="col flex-2">
                    <input type="checkbox" :checked="isBoolean(FHIR.isECALSession)" disabled />
                </div>    
                <div class="col flex-2">
                  {{ FHIR.releaseVersion }}
                </div>                               
                <div class="col">
                  <span class="btn btn-primary" @click="editModal(FHIR)" title="Edit" style="padding-right: 10px;margin-right:10px;left:0">
                   Edit
                  </span>
                  <span class="btn btn-primary" @click="deleteRow(FHIR)" title="Delete" style="padding-right: 10px">
                    Delete
                  </span>
                </div>
               
              </div>
            </div>
          </div>
        </div>
        <div v-if="listEmpty == true">
            <h3>No results found</h3>
          </div>
      </div>
    </div>
    <!-- Edit model constrection starts from here  -->
    <b-modal id="addModal" hide-backdrop centered v-bind:title="okFhirTitle" title-class="test" :ok-title="okFhirTitleBtn"
             @ok="handleOkClick()" @hidden="clearModal" @cancel="clearModal" no-close-on-esc no-close-on-backdrop>
      <div class="edit-form-container">
        <b-form ref="form">
          <b-form-group >
            <label class="custom-form-label">FHIR OAuth Url (Id) :</label>
            <b-form-input id="fhir_id" v-model="addObj._id"
                           placeholder="Enter Id"
                          :disabled="editActionModal"></b-form-input>
          </b-form-group>
          <b-form-group >
            <label class="custom-form-label">Client Id :</label>
            <b-form-input id="clientId" v-model="addObj.clientId"
                           placeholder="Enter Client Id"
                          :disabled=false></b-form-input>
          </b-form-group>
          <b-form-group >
            <label class="custom-form-label">Scope :</label>
            <b-form-input id="scope" v-model="addObj.scope"
                           placeholder="Enter Scope"
                          :disabled=false></b-form-input>
          </b-form-group>
          <b-form-group >
            <label class="custom-form-label">MRN_MONIKER :</label>
            <b-form-input id="MRN_MONIKER" v-model="addObj.MRN_MONIKER"
                           placeholder="Enter MRN MONIKER"
                          :disabled=false></b-form-input>
          </b-form-group>
          <b-form-group >
            <label class="custom-form-label">MRN_SYSTEM_ID :</label>
            <b-form-input id="MRN_SYSTEM_ID" v-model="addObj.MRN_SYSTEM_ID"
                           placeholder="Enter MRN SYSTEM ID"
                          :disabled=false></b-form-input>
          </b-form-group>
          <b-form-group >
            <label class="custom-form-label">MRN_FORMAT :</label>
            <b-form-input id="MRN_FORMAT" v-model="addObj.MRN_FORMAT"
                           placeholder="Enter MRN FORMAT"
                          :disabled=false></b-form-input>
          </b-form-group>
          <b-form-group>
            <b-form-checkbox id="checkbox-isLab" v-model="addObj.isLab" name="isLab"
                             unchecked-value="false" value="true" inline>
              IsLab
            </b-form-checkbox>
          </b-form-group>
          <b-form-group>
            <b-form-checkbox id="checkbox-isEcal" v-model="addObj.isECALSession" name="isEcal"
                             unchecked-value="false" value="true" inline :disabled="editActionModal">
              isEcal
            </b-form-checkbox>
          </b-form-group>
          <b-form-group >
            <label class="custom-form-label">Release Version :</label>
<!--            <b-form-input id="scope" v-model="addObj.releaseVersion"-->
<!--                           placeholder="Enter Release Version"-->
<!--                          :disabled=false></b-form-input>-->
            <br>
            <select placeholder="Select Release Version" v-model="addObj.releaseVersion" class="inputSelect">
              <option value="">Please select Release Version</option>
              <option v-for="option in releaseVersionOptions" v-bind:key="option.id" :value="option.id">
                {{ option.name }}
              </option>
            </select>
          </b-form-group>
        </b-form>
      </div>
    </b-modal>
    <!-- delete-modal -->
   
    <div v-if="showDeleteModal==true">
        <div class="areYouSureWrapper row m-0 align-items-center">
          <div class="popUpContent">
            <div class="popupHead">
              <span aria-hidden="true" class="close-button-container" @click="showDeleteModal = false">&times;</span>
            </div>
            <div class="popupBody">
              Are you sure you want to delete the Row?
            </div>
            <div class="popupFooter">
              <div class="yesBtn btn" @click="deleteRowConfirm($event)">
                Yes
              </div>
              <div class="noBtn btn" @click="showDeleteModal = false">No</div>
            </div>
          </div>
        </div>
      </div>
  </section>
</template>
<script>
import Vue from "vue";
import VueToast from "vue-toast-notification";
import Multiselect from "vue-multiselect";
import "vue-search-select/dist/VueSearchSelect.css";
import { ModelSelect } from "vue-search-select";
import cloneDeep from 'lodash/cloneDeep';


Vue.use(VueToast);
Vue.component("multiselect", Multiselect);
export default {
  components: {
    ModelSelect,
    Multiselect
  },
  data() {
    return {
      tenants: [{ text: "-SELECT-", value: "" }],
      tenantsList: [],
      editActionModal:false,
      list:[],
      FHIRSettings: [{
       "_id": "https://vendorservices.epic.com/interconnect-amcurprd-oauth/api/FHIR/R4",
      "clientId": "4d55f473-051f-4835-ae80-804e7b84a823",
      "scope": "patient/*.read openid fhirUser",
       "tenant": "lab",
       "isLab": false
       },{
       "_id": "ECAL:https://vendorservices.epic.com/interconnect-amcurprd-oauth/api/FHIR/R4",
       "clientId": "5f03e048-e5f4-4827-990f-a956dd8d3c98",
       "scope": "patient/*.read openid fhirUser",
       "tenant": "lab",
        "isLab": false,
       "isECALSession": true
      }] ,
      listData:{},
      okFhirTitle:"Add",
      okFhirTitleBtn:"Add",
      lastSelectedTenant: "",
      lastSelectedTenantObj: "",
      tenantOpt: "",
      showDeleteModal: false,
      addObj: {
      _id:"",
      isLab:false,
      isECALSession:false,
      scope:'',
      clientId:'',
      releaseVersion:'',
      tenant:'',
      MRN_SYSTEM_ID:'',
      MRN_MONIKER:'',
      MRN_FORMAT:''
      },
      listEmpty:false,
      defaultAddObj: {
      _id:"",
      isLab:false,
      isECALSession:false,
      scope:'',
      clientId:'',
      releaseVersion:'',
      tenant:'',
      MRN_SYSTEM_ID:'',
      MRN_MONIKER:'',
      MRN_FORMAT:''
      },
      deleteObj:{},
      commandError:"",
      releaseVersionOptions: [
        {
          id: "ER",
          name: "Early Release"
        },
        {
          id: "RC",
          name: "Release Candidate"
        }, {
          id: "GA",
          name: "General Availability"
        }
      ]
    };
  },

  mounted() {
    this.fetchData();
    this.fetchTenants();
    $("input").attr("autocomplete", "off");
  },
  methods: {
    isBoolean(value){
      return value === 'true' ? true : value === 'false' ? false : Boolean(value);
    },
    async fetchTenants() {
      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      var tenants_list_request = new Request(
        config.TENET_SERVICE + "/tenants/?list=true",
        {
          method: "GET",
          mode: "cors",
          cache: "default",
          withCredentials: true,
          credentials: "include",
          headers: {
            Authorization: "Bearer " + id_token,
            "Content-Type": "application/json"
          }
        }
      );
      try {
        var tenants_list = await fetch(tenants_list_request);
        if (tenants_list.status == 503) {
          return this.fetchTenants();
        }
        var response = await tenants_list.json();
        this.tenants = response
          .map((t) => {
            return {
              text: t.text || t.value,
              id: t.value,
              value: t.value.toLowerCase().replace("-", "")
            };
          })
          .sort((a, b) => {
            return a.text.localeCompare(b.text);
          });
        this.tenants.forEach((e) =>
          this.tenantsList.push({ id: e.value, name: e.text || e.value })
        );
      
      } catch (error) {
        console.error(error);
      }
    },
    editModal(fhirObj) {
    
    this.addObj=cloneDeep(fhirObj);
    this.editActionModal=true;
      this.okFhirTitle = `Update- [${this.tenantOpt}]`;
      this.okFhirTitleBtn = "Update";
      this.$bvModal.show("addModal");
    },
     deleteRow(rowData){
     
     this.deleteObj=rowData;
      this.showDeleteModal=true;
    },
   async deleteRowConfirm(event){
    const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      var url =
        config.OPERATIONS_SERVICE +
        `/tenants/${this.lastSelectedTenant}/delete-fhir-settings`;
       
      var delete_fhir = new Request(url, {
        method: "DELETE",
        mode: "cors",
        withCredentials: true,
        credentials: "include",
        body: JSON.stringify({
          id: this.deleteObj._id,
          tenant: this.lastSelectedTenant
        }),
        headers: {
          Authorization: "Bearer " + id_token,
          "Content-Type": "application/json"
        }
      });
      try {
        var deleteResponse = await fetch(delete_fhir);
        if(deleteResponse){
          this.showDeleteModal = false;
        Vue.$toast.open({
          message: "Data deleted successfully.",
          type: "success"
        });
        this.fetchData();
        }
      } catch (err) {
        Vue.$toast.open({
          message: "Failed to Delete Data.",
          type: "error"
        });
        console.error("Failed to Delete Data.", err);
      }
   },
    getTenantId(Obj) {
      let objVal = this.tenants.find(e => e.value == Obj);
      if (objVal) {
        return objVal.id;
      } else {
        return "";
      }
    },
    validateSelection() {
      this.lastSelectedTenant = this.getTenantId(this.lastSelectedTenantObj);
      this.tenantOpt = this.lastSelectedTenant;
      this.fetchData();
    },
 

    async showEPHRModal() {
      this.$bvModal.show("addModal");
    },
    async clearModal() {
      this.$bvModal.hide("addModal");
      this.okFhirTitle="Add",
      this.okFhirTitleBtn="Add",
      this.editActionModal=false,
      this.addObj = this.defaultAddObj
    },
    async fetchData() {
      if (this.lastSelectedTenant) {
        let loader = Vue.$loading.show({
        // Optional parameters
        color: "skyblue",
        opacity: 0.1,
        loader: "dots",
      });
        this.listEmpty = false;
        this.list = [];
        const claims = await this.$auth.getIdTokenClaims();
        const id_token = claims.__raw;
        var Url =
          config.OPERATIONS_SERVICE +`/tenants/${this.tenantOpt}/get-fhir-settings`;
        try {
          const res = await fetch(Url, {
            method: "GET",
            mode: "cors",
            withCredentials: true,
            cache: "default",
            headers: {
              Authorization: "Bearer " + id_token,
              "Content-Type": "application/json"
            }
          });
          if (res.status === 503) {
            return this.fetchData();
          } else {
            const newRes = await res.json();

            this.list = newRes;
            if (this.list.length == 0) {
              loader.hide();
              this.listEmpty = true;
            } else if (this.list.length > 0) {
              loader.hide();
              this.listEmpty = false;
            }
          }
        } catch (err) {
          console.log(err);
        }
      }
    },
    async addEPHRModal(){
      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      this.addObj['isLab']=this.isBoolean(this.addObj['isLab']);
      this.addObj['isECALSession']=this.isBoolean(this.addObj['isECALSession']);

      this.addObj['tenant']=this.tenantOpt;
      var url =
        config.OPERATIONS_SERVICE +`/tenants/${this.tenantOpt}/add-fhir-settings`;
      var add_data = new Request(url, {
        method: "POST",
        mode: "cors",
        withCredentials: true,
        credentials: "include",
        cache: "default",
        body: JSON.stringify(this.addObj),
        headers: {
          Authorization: "Bearer " + id_token,
          "Content-Type": "application/json"
        }
      });
      try {
        var fhirSettingsResponse = await fetch(add_data);
        if (fhirSettingsResponse.status === 403) {
          this.errorMessage =
            "Uh oh... You don't have the permission required to insert fhir settings";
          Vue.$toast.open({ message: this.errorMessage, type: "error" });
          return;
        }
        if (fhirSettingsResponse.status == 401) {
          this.errorMessage =
            "Your session has expired please login again to continue";
          Vue.$toast.open({ message: this.errorMessage, type: "error" });
          return;
        }
        if (fhirSettingsResponse.status == 503) {
          return this.addEPHRModal();
        }
        if (fhirSettingsResponse.status != 200) {
          this.commandError = "Failed to insert FHIR settings";
          Vue.$toast.open({ message: this.commandError, type: "error" });
        } 
          if(!fhirSettingsResponse['ok']){
            Vue.$toast.open({
            message:"FHIR Setting with the same id already exists, Please try different.",
            type: "warning"
          });
          }else{
          Vue.$toast.open({
            message:
              "FHIR settings inserted successfully. Please clear the cache to show effect of the latest.",
            type: "success"
          });
          this.fetchData();
          //clearing the model object on every successfull insertion
          this.addObj = this.defaultAddObj;
          this.okFhirTitle = "Add";
          this.okFhirTitleBtn = "Add";
          this.clearModal();
        }
          
        
      } catch (tex) {
        this.commandError = "Failed to insert fhir settings due to an error.";
        Vue.$toast.open({ message: this.commandError, type: "error" });
      }
    },

    async updateEPHRModal() {
      this.addObj['tenant']=this.addObj['tenant']? this.addObj['tenant']:this.tenantOpt;
      this.addObj['isLab']=this.isBoolean(this.addObj['isLab']);
      this.addObj['isECALSession']=this.isBoolean(this.addObj['isECALSession']);
      //edit action
      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      var url =config.OPERATIONS_SERVICE +`/tenants/${this.tenantOpt}/update-fhir-settings`;
      var update_data = new Request(url, {
        method: "PATCH",
        mode: "cors",
        withCredentials: true,
        credentials: "include",
        cache: "default",
        body: JSON.stringify(this.addObj),
        headers: {
          Authorization: "Bearer " + id_token,
          "Content-Type": "application/json"
        }
      });
      try {
        var fhirSettingsResponse = await fetch(update_data);
        if (fhirSettingsResponse.status === 403) {
          this.errorMessage =
            "Uh oh... You don't have the permission required to access this resource";
          Vue.$toast.open({ message: this.errorMessage, type: "error" });
          return;
        }
        if (fhirSettingsResponse.status == 401) {
          this.errorMessage =
            "Your session has expired please login again to continue";
          Vue.$toast.open({ message: this.errorMessage, type: "error" });
          return;
        }
        if (fhirSettingsResponse.status == 503) {
          return this.updateEPHRModal();
        }
        if (fhirSettingsResponse.status != 200) {
          this.commandError = "Failed to update fhir settings";
          Vue.$toast.open({ message: this.commandError, type: "error" });
        } else {
          this.commandError = "";
          Vue.$toast.open({
            message:
              "FHIR settings updated successfully. Please clear the cache to show effect of the update.",
            type: "success"
          });
          this.editActionModal=false;
          this.fetchData();
          //clearing the model object on every successfull insertion
          this.addObj = this.defaultAddObj;
          this.okFhirTitle = "Add";
          this.okFhirTitleBtn = "Update";
          this.clearModal();
        }
      } catch (tex) {
        this.commandError = "Failed to update fhir settings due to an error.";
        Vue.$toast.open({ message: this.commandError, type: "error" });
      }
    },
    handleOkClick() {
      // Conditionally choose a function to call based on editActionModal condition
      if (this.editActionModal) {
        this.updateEPHRModal();
      } else {
        this.addEPHRModal();
      }
    },
  }
};
</script>
<style lang="scss" scoped>
@font-face {
  font-family: GTWalsheimPro-Regular;
  src: url(../assets/fonts/GTWalsheimPro-Regular.eot);
  src: url(../assets/fonts/GTWalsheimPro-Regular.eot) format("embedded-opentype"),
  url(../assets/fonts/GTWalsheimPro-Regular.ttf) format("truetype"),
  url(../assets/fonts/GTWalsheimPro-Regular.svg) format("svg");
  font-weight: normal;
  font-style: normal;
}

::v-deep .ui.search.dropdown .text {
  max-width: 230px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  height: 15px;
}

*,
:after,
:before {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

body,
html {
  font-family: GTWalsheimPro-Regular !important;
  background: #fff !important;
  font-size: 16px;
  overflow-x: hidden;
}

b,
strong {
  font-weight: 500;
}

.pageHeaderTitle {
  padding-left: 15px !important;
}

button,
html input[type="button"],
input[type="reset"],
input[type="submit"] {
  -webkit-appearance: button;
  cursor: pointer;
}

button[disabled],
html input[disabled] {
  cursor: default;
  pointer-events: none;
}

button::-moz-focus-inner,
input::-moz-focus-inner {
  border: 0;
  padding: 0;
  outline: 0 !important;
}


input[type="text"],
input[type="email"],
input[type="search"],
input[type="number"],
input[type="password"],
input[type="tel"],
input[type="date"],
select.form-control,
textarea.form-control {
  box-shadow: none;
  background: transparent;
  outline: none !important;
  border: 1px solid #dceaea;
  border-radius: 5px;
  width: 100%;
  padding: 7px 15px;
  color: #6a6a6a;
}


/* Scroll Bar Styling */

/* width */
::-webkit-scrollbar {
  width: 5px;
  border-radius: 10px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f2fdff;
  border-radius: 10px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #a6e3f0;
  border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #a6e3f0;
  border-radius: 10px;
}
.btn {
  background: #1dd8f6;

  color: #fff;
  // position:absolute;
  // top:250px;
  // left:500px;
  border-color: #1dd8f6;
  padding: 5px 10px;
  border: 0px;
}
/* Checkbox CSS Starts here */


/* Checkbox CSS ends here */
.bodyArea {
  font-family: GTWalsheimPro-Regular;
}

/* Header CSS */
.headerWrapper {
  height: 80px;
  border-bottom: 1px solid #e5f0f2;
  width: 100%;
  padding: 0 15px;
}



.infoWrapper {
  padding: 10px 20px;
  border-left: 1px solid #e5f0f2;
}

.infoItem {
  display: flex;
  line-height: 20px;
}

.pageHeader {
  height: 56px;
  color: #fff;
  background: #484848;
  font-size: 15px;
  padding: 0 15px;
}

.filterWrapper {
  background: #575757;
  display: inline-flex;
  padding: 0px 10px;
  font-size: 16px;
  min-width: 360px;
  max-width: 360px;
  border-radius: 5px;
  margin-left: 15px;
  // max-width: 280px;
  align-items: center;
  text-overflow: ellipsis;
}

.generalBtn {
    background: #575757;
    display: inline-flex;
    padding: 0px 10px;
    font-size: 16px;
    border-radius: 5px;
    margin-left: 10px;
    width: auto;
    line-height: 36px;
}
.generalBtn:hover{
  background:#1dd8f6;
}

.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  background: transparent !important;
}


.modal-header {
  background: #50b9d4;
  color: #fff;
}

.modal-title {
  font-size: 14px !important;
}

.modal-body {
  color: #7b7b7b;
}

.modal-footer {
  background: #f2fdff;
  color: #1a80a8;
  justify-content: center;
}

.modal-footer .btn {
  padding: 5px 20px;
  border-radius: 6px;
  min-width: 100px;
  //border: 1px solid #50B9D4 !important;
}

.modal-footer .btn:hover {
  background: #fff;
  color: #50b9d4;
  cursor: pointer;
}

.modal-footer > :not(:last-child) {
  margin-right: 15px;
}

.modal-footer > :not(:first-child) {
  margin-left: 15px;
}


.pageDataWrapper {
  padding: 20px;
}

.tableDataWrapper {
}

.contentHeader {
  background: #ebebeb;
  height: 42px;
  color: #484848;
  border-radius: 5px;
}

.contentHeader > div {
  border-left: 1px solid #c7c7c7; 
  display: inline-flex;
  align-items: center;
  font-size: 18px !important;
}

.contentHeader > div:first-child {
  border-left: 0px solid;
}

.contentHeader td {
  padding: 0 15px;
}

.contentRow > td {
  border-bottom: 1px solid #daf9ff;
  align-items: center;
  padding: 0 15px;
  background: #fff !important;
  color: #6a6a6a;
  cursor: pointer;
}

.contentRow.error td {
  background: #f16161 !important;
  color: #fff;
}

.contentRow.active td {
  background-color: #f4fbfe !important;
}

.contentRow:hover td {
  background-color: #f4fbfe !important;
}

.contentRow.error:hover td {
  background-color: #f57676 !important;
}

.contentDataWrap {
  overflow: auto;
  overflow-y: auto;
  height: 30vh;
}

.contentDataWrapBottom {
  overflow: auto;
  overflow-y: auto;
  height: 100%;
  font-size: 16px !important;
}

.contentDataWrapper {
  align-content: flex-start;
}

.contentRow {
  height: 50px;
}

.contentData {
  background: #fff;
  color: #6a6a6a;
  height: auto;
  margin-top: 10px !important;
  cursor: pointer;
  min-height: 48px;
  border: 1px solid #ebebeb;
  border-radius: 5px;
}

.contentData:hover,
.contentData.active {
  background: #f2fdff;
}

.contentData > div {
  border-left: 1px solid #e7e7e7;
  align-items: center;
  text-overflow: ellipsis;
  overflow: hidden;
  display: inline-block;
}

.contentData > div:first-child {
  border-left: 0px solid;
}


#tenantConnectionId option {
  color: #6a6a6a;
}

.subHeadWrap {
  line-height: 35px;
  padding: 0 32px 0px 5px;
}

.areYouSureWrapper {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  justify-content: center;
  background: rgba(0, 0, 0, 0.2);
}

.popUpContent {
  min-width: 350px;
  max-width: 350px;
  border-radius: 10px;
  background: #fff;
}

.popupHead {
  background: #f7f7f7;
  line-height: 40px;
  border-radius: 10px 10px 0 0;
  color: #fff;
  padding: 0 15px;
  height: 40px;
}

.popupHead span {
  float: right;
}

.popupBody {
  color: #6a6a6a;
  padding: 15px;
}

.filterWrapper .dropdown:before {
  content: "";
  border: solid #8e8e8e;
  border-width: 0 1px 1px 0;
  display: inline-block;
  padding: 3px;
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
  position: absolute;
  right: 0px;
  top: 15px;
}

.popupFooter {
  border-radius: 0px 0px 10px 10px;
  background: #fff;
  color: #6a6a6a;
  padding: 15px;
  justify-content: center;
  text-align: center;
  border-top:1px solid #ebebeb;
}

.yesBtn,
.noBtn {
  margin-right: 10px;
  
  border-radius: 5px;
  padding: 5px 20px !important;
}

.yesBtn {
  background:#66BE6D;
  border: 1px solid #66BE6D;
}

.noBtn {
  margin-left: 0;
  margin-right: 0px;
  background:#F27778;
  border: 1px solid #F27778;
}

.yesBtn:hover{
  background: #3FAA48 !important;
  border: 1px solid #3FAA48 !important;
}

.noBtn:hover {
  background: #E62829 !important;
  border: 1px solid #E62829 !important;
}

h3 {
  padding: 20px 20px 0;
  color: #1a80a8;
  font-size: 24px;
  margin: 0;
  font-family: "GTWalsheimPro-Regular";
  font-weight: 400;
}

.v-toast__item .toast-bgclass {
  background-color: #f16161 !important;
}



.full-width {
  width: calc(100% - 40px);
}

//form basic designs follwed in the application are taken for our form
#addModal___BV_modal_title_ {
  color: white;
  font-weight: 200;
}

#addModal___BV_modal_body_ {
  color: #1dd8f6;
}

.form-control {
  color: #6a6a6a;
}

#addModal___BV_modal_footer_ .btn {
  background-color: #1dd8f6;
  border: none;
  border-radius: 5px;
}

.modal-header {
  background-color: #f7f7f7;
  padding:12px 15px;
  align-items:center;
}

.in-valid {
  border-color: #dc1414 !important;
}

.valid {
  border-color: #fff !important;
}

.actionBtn.clientShowBtn.btn-secondary.canTo {
  border-radius: 5px;
  min-width: 60px;
  text-align: center !important;
  display: block;
  line-height: 30px;
  padding: 0 10px;
  cursor: pointer;
  font-size: 16px;
  margin: 5px 0;
}
#addModal{

.edit-form-container {
  max-height: 800px;
  overflow-y: auto;
  padding: 1rem;
}
.custom-form-label {
  color: #3288D2 !important;
    font-family: GTWalsheimPro-Regular !important;
    font-size: 16px;
    font-weight: 400;
}
.btn .btn-secondary{

}


}
::v-deep #addModal .custom-control-label{
  color: #7a8991 !important;
  font-family: GTWalsheimPro-Regular;
}
::v-deep #addModal .modal-body{
    padding:0px;
}
::v-deep #addModal .modal-dialog{
 margin: 1.75rem auto;
}
::v-deep #addModal .modal-content{
  -webkit-box-shadow: 0px 0px 33px -11px rgba(17, 30, 54, 1);
  -moz-box-shadow: 0px 0px 33px -11px rgba(17, 30, 54, 1);
  box-shadow: 0px 0px 33px -11px rgba(17, 30, 54, 1);
}
.close-button-container{
  font-size: 18px;
  cursor: pointer;
  color: #484848;
}

.pageHeader  ::v-deep .ui.default.dropdown:not(.button)>input:focus~.text, .pageHeader  ::v-deep .ui.dropdown:not(.button)>input:focus~.default.text,.pageHeader ::v-deep .ui.active.search.dropdown input.search:focus+.text{
  color:#fff !important;
}

::v-deep .ui.selection.active.dropdown .menu {
  border: 1px solid #EBEBEB;
  box-shadow: 0 2px 3px 0 rgba(34, 36, 38, .15);
  padding: 10px 0;
  margin-top: 1px;
  border-top-width: 1px !important;
}


::v-deep .ui.selection.active.dropdown:hover,::v-deep .ui.selection.active.dropdown{
  box-shadow:none;
}

::v-deep .ui.dropdown .menu>.item:hover{
  color:#1dd8f6;
  background:#EAF9FF !important;
}
::v-deep .ui.dropdown .menu>.item.selected{
  color:#1dd8f6;
  background:#fff;
}
@media only screen and (max-width: 1680px) {
  .contentHeader > div{
    font-size: 17px !important;
  }
  .contentData > div > span:first-child{
    margin-right: 5px !important;
  }
}
</style>
